import {
    Component, Input, OnChanges, SimpleChanges
} from "@angular/core";


@Component({
    selector: 'app-results-table',
    templateUrl: './results-table.component.html'
})

export class ResultsTableComponent implements OnChanges {
    @Input() results = [];
    subtotal = { description: 'Subtotal', amount: 0 };
    constructor() { }
    ngOnChanges(changes: SimpleChanges) {
        if ('results' in changes) {
            let results = changes['results'].currentValue;
            if (results) {
                this.subtotal.amount = 0;
                results.forEach(result => {
                    this.subtotal.amount += result.amount;
                });
                results.push(this.subtotal);
                this.results = results;
            }
        }
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/results-table/results-table.component.ts